import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb2c4768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-edit" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = {
  key: 0,
  class: "invoice-edit__block flex flex-col justify-center items-center text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-gray-400 font-semibold text-sm" }, " Загрузка данных накладной... ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 font-semibold text-sm" }, " Произошла ошибка при получении данных о накладной ", -1))
const _hoisted_8 = { class: "invoice-edit__block mt-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block__title" }, "Получатель", -1))
const _hoisted_10 = { class: "StepReceivers__receiver mt-2" }
const _hoisted_11 = { class: "text-blue-600 font-semibold" }
const _hoisted_12 = { class: "mt-2 text-sm" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_15 = { class: "block" }
const _hoisted_16 = { class: "flex items-center mt-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile mr-3" }, null, -1))
const _hoisted_18 = { class: "block" }
const _hoisted_19 = { class: "flex items-center mt-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt mr-3" }, null, -1))
const _hoisted_21 = { class: "block" }
const _hoisted_22 = {
  key: 0,
  class: "mt-2 font-semibold"
}
const _hoisted_23 = {
  key: 0,
  class: "mt-3 flex items-center justify-end"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_templates_actions = _resolveComponent("templates-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_step_cargo = _resolveComponent("step-cargo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_templates_actions, {
          key: 0,
          "is-create": false,
          "is-delete": false,
          "is-receiver": true,
          "is-update": _ctx.actions_state.is_update,
          loading: _ctx.actions_state.is_actions_loading,
          "company-id": _ctx.state.invoice.company_id,
          "sender-id": _ctx.state.invoice.sender.id,
          "sender-city-id": _ctx.state.invoice.sender.city_id,
          "load-by-sender-city-id": "",
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onUpdate: _ctx.onReceiverUpdate
        }, null, 8, ["is-update", "loading", "company-id", "sender-id", "sender-city-id", "initial-value", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        title: `Редактирование накладной (ID: ${_ctx.$route.params.invoice_id})`
      }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.state.is_loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_6
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_7,
                    _createVNode(_component_the_button, {
                      class: "primary small mt-1",
                      loading: _ctx.state.is_loading,
                      onClick: _ctx.loadInvoice
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Обновить ")
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.state.invoice.receiver.title), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.state.invoice.receiver.full_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, [
                      (_ctx.state.invoice.receiver.additional_phone)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.state.invoice.receiver.phone) + ", " + _toDisplayString(_ctx.state.invoice.receiver.additional_phone), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.state.invoice.receiver.phone), 1)
                          ], 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.state.invoice.receiver.full_address), 1)
                  ]),
                  (Boolean(_ctx.state.invoice.receiver.warehouse_id))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Самовывоз "))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.isOnBeforeHandling || _ctx.isOnBeforeGivingOnDelivery)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_the_button, {
                      class: "primary small text",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startUpdate(_ctx.state.invoice.receiver)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _createTextVNode(" Редактировать ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isOnBeforeHandling)
              ? (_openBlock(), _createBlock(_component_step_cargo, {
                  key: 0,
                  class: "mt-6",
                  "step-number": 2,
                  opened: _ctx.state.is_loaded,
                  "take-date": _ctx.state.invoice.take_date,
                  "period-id": _ctx.state.invoice.period_id,
                  "updating-cargo": _ctx.state.updating_cargo,
                  "invoice-id": _ctx.invoice_id,
                  "company-id": _ctx.state.invoice.company_id,
                  receiver: _ctx.state.invoice.receiver,
                  "sender-city-id": _ctx.state.invoice.sender.city_id,
                  "receiver-city-type": _ctx.state.invoice.receiver ? _ctx.state.invoice.receiver.city_type : null,
                  "is-update": "",
                  "is-update-created-cargo": "",
                  "is-update-invoice": "",
                  onSubmit: _ctx.onCargoUpdated
                }, null, 8, ["opened", "take-date", "period-id", "updating-cargo", "invoice-id", "company-id", "receiver", "sender-city-id", "receiver-city-type", "onSubmit"]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ]))
}